<template>
  <v-card>
    <v-card-title style="background-color: #004056" class="white--text">
      Open this lead?
    </v-card-title>

    <v-divider />

    <v-card-text class="mt-4">
      <div><strong>Yes I want this lead!</strong></div>

      <div class="mt-5">
        Your balance is {{ formatCurrency(me.balance_cents) }}, but this lead will cost
        {{ formatCurrency(lead.price_cents) }}  <em>(plus tax)</em>. You need to add
        to your balance to claim this lead.
      </div>
      <div class="mt-5">
        Don't miss out!.
      </div>
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-center py-3">
      <v-btn @click="close">Cancel</v-btn>
      <v-btn color="primary" @click="confirm">Add Balance</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formatters from '@/lib/formatters'
import { mapGetters } from 'vuex'

export default {
  name: 'UnopenedLeadInsufficient',

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('auth', ['me']),
  },

  methods: {
    ...formatters,

    close() {
      this.$emit('close')
    },

    confirm() {
      this.$router.push( { name: 'billing/add_balance' })
    },
  }
}
</script>